const isMock = process.env.REACT_APP_MOCK === 'true'
  && process.env.NODE_ENV !== 'production';

export default isMock;
